import React, { Children, useState } from 'react';
import { IconAsChunk } from '@boschebike/ebds-react-icons';
import classNames from '../helpers/classNames.js';
import Button from './Button.js';
import Container from './Container.js';
const IconToggle = () => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("rect", {
  x: "0",
  y: "11.25",
  width: "24",
  height: "1.5",
  className: "one"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "12.75 0 12.75 24 11.25 24 11.25 0",
  className: "two"
}));
const getValidDate = date => {
  try {
    const d = new Date(date);
    d.toISOString();
    return d;
  } catch (error) {
    console.error('INVALID DATE PASSED TO UpdateFeedItem!');
    return false;
  }
};
export const UpdateFeedItem = ({
  lang = 'en-GB',
  title,
  date,
  intro,
  rest = null,
  readMoreLabel
}) => {
  const [expanded, setExpanded] = useState(false);
  const validDate = getValidDate(date);
  const className = classNames('ebds-update-feed__item');
  const ddClassNames = classNames('ebds-update-feed__item__dd', {
    '--has-more': !!rest,
    '--expanded': expanded
  });
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("dt", null, /*#__PURE__*/React.createElement("span", null, title), validDate ? /*#__PURE__*/React.createElement("time", {
    dateTime: validDate.toISOString()
  }, validDate.toLocaleDateString(lang)) : null), /*#__PURE__*/React.createElement("dd", {
    className: ddClassNames
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: intro
    }
  }), rest ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: rest
    }
  }) : null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    mode: Button.modes.TERTIARY,
    onClick: () => setExpanded(!expanded),
    icon: /*#__PURE__*/React.createElement(IconAsChunk, {
      iconName: "down"
    }),
    text: readMoreLabel
  }))));
};
export const UpdateFeed = ({
  headline,
  subHeadline,
  readMoreLabel = null,
  feedVisibleLimit = 3,
  children,
  withLimits,
  linkMoreLabel = null,
  linkMoreUrl = null
}) => {
  if (withLimits && !readMoreLabel) {
    console.warn('radMoreLabel is missing while withLimits is enabled.');
  }
  const linkMore = linkMoreLabel && linkMoreUrl ? /*#__PURE__*/React.createElement(Button, {
    text: linkMoreLabel,
    href: linkMoreUrl,
    mode: Button.modes.SECONDARY,
    icon: /*#__PURE__*/React.createElement(IconAsChunk, {
      iconName: "ArrowRightUpFrame"
    })
  }) : null;
  const childrenCount = Children.count(children);
  const hasMoreThanLimit = feedVisibleLimit < childrenCount;
  const enableLimits = withLimits && hasMoreThanLimit;
  // Brain damage below.
  // if user wants to limit items, and there are more items than limit, so we enable limits,
  // then DO NOT show more as default, because there's a button that will offer reveal.
  const [showMore, setShowMore] = useState(false);
  const buttonClassNames = classNames('ebds-update-feed__button', {
    '--expanded': showMore
  });
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("section", {
    className: "ebds-update-feed"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "ebds-heading--with-subheadline-first"
  }, /*#__PURE__*/React.createElement("span", null, subHeadline), headline), /*#__PURE__*/React.createElement("dl", {
    className: "ebds-update-feed__items"
  }, !enableLimits || showMore ? children : Children.map(children, (child, index) => {
    if (index < feedVisibleLimit) {
      return child;
    }
    return null;
  })), !withLimits && linkMore ? /*#__PURE__*/React.createElement("div", {
    className: "ebds-update-feed__button"
  }, linkMore) : null, enableLimits ? /*#__PURE__*/React.createElement("div", {
    className: buttonClassNames
  }, /*#__PURE__*/React.createElement(Button, {
    mode: Button.modes.SECONDARY,
    onClick: () => {
      setShowMore(!showMore);
    },
    icon: /*#__PURE__*/React.createElement(IconToggle, null),
    text: readMoreLabel
  })) : null));
};